import { render, staticRenderFns } from "./shopset.vue?vue&type=template&id=8fc6961e&scoped=true&"
import script from "./shopset.vue?vue&type=script&lang=js&"
export * from "./shopset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc6961e",
  null
  
)

export default component.exports